export default "__VITE_ASSET__BNFemIat__"